<template>
  <div>
    <label v-if="showLabel"
           :for="name"
           class="block text-sm font-medium text-gray-700">
      {{ displayLabel }}
    </label>
    <div class="mt-1">
      <select :name="name"
              v-model="value"
              :disabled="disabled"
              :class="{ '-error': error, '-full-width': fullWidth }">
        <option :value="null" v-if="nullable"></option>
        <option v-for="item in normalizedOptions" :value="item.value">{{ item.label }}</option>
      </select>
    </div>

    <p v-if="error" class="mt-2 text-sm text-red-600">{{ error }}</p>
  </div>
</template>

<script>
import FormCommon from './form-mixin'

export default {
  mixins: [
    FormCommon,
  ],

  props: {
    modelValue: {
      type: [String, Number],
    },
    options: Array,
    showLabel: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    nullable: {
      type: Boolean,
      default: false,
    },
    fullWidth: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      value: this.modelValue,
      normalizedOptions: this.options.map(item => (typeof item === 'string')
        ? { value: item, label: item }
        : item
      )
    }
  },

  watch: {
    value(newValue) {
      this.$emit('update:modelValue', newValue)
    }
  },
}
</script>

<style scoped>
select {
  @apply max-w-lg block focus:ring-indigo-500 focus:border-indigo-500 w-full shadow-sm sm:max-w-xs sm:text-sm border-gray-300 rounded-md;

  &.-error {
    @apply border-red-300 text-red-900 placeholder-red-300 focus:ring-red-500 focus:border-red-500;
  }

  &.-full-width {
    max-width: inherit;
  }

  &[disabled] {
    @apply text-gray-400;
  }
}
</style>
